export default __webpack_public_path__ + "static/media/VSAImg.77bd39c4.jpg";